import { jsx as _jsx } from "react/jsx-runtime";
import { useContactContext, useContactSections } from "@/contexts/contact";
import { useI18n } from "@/shared/hooks";
import { FeedbackMessage } from "@gemini/ui";
import { energyTestId } from "./Energy";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const EnergyCTA = ({ variant }) => {
    var _a;
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    const { toggleModal } = useContactContext();
    const isPrivateOwner = (_a = useContactSections()) === null || _a === void 0 ? void 0 : _a.contactCard.isPrivateOwner;
    const isNoEnergyData = variant === "no-data";
    const providerText = isPrivateOwner
        ? t("contact.form.owner_provider_text")
        : t("contact.form.agent_provider_text");
    const testId = `${energyTestId}-info-not-available`;
    const btnText = t("energy.description.fallback.cta").replace("{value}", providerText.toLowerCase());
    const infoText = isNoEnergyData
        ? t("energy.no_data_provided")
        : t("energy.energy_scale.no_data_provided");
    const infoLabel = infoText.replace("{value}", providerText);
    return (_jsx(FeedbackMessage, { testId: testId, variant: "info", startButtonProps: {
            children: btnText,
            onPress: () => {
                toggleModal({
                    av_zone: "energy_notavailable",
                    legacyTrackingInfos: "energy_notavailable",
                });
            },
            isDisabled: isPreviewMode,
        }, marginBottom: isNoEnergyData ? "spacing.none" : "spacing.16", children: infoLabel }));
};
